import React from 'react';
import { WebsiteBuilderBackButton } from './_back-button/website-builder-back-button';
import { WebsiteBuilderToolbar } from './_toolbar/website-builder-toolbar';
import './website-builder-header.scss';

type WebsiteBuilderHeaderProps = {
    onBack: () => void;
    hubName: string;
    hubUrl: string | null;
};

export const WebsiteBuilderHeader = ({ onBack, hubName, hubUrl }: WebsiteBuilderHeaderProps) => {
    return (
        <div className='website-builder-header'>
            <WebsiteBuilderBackButton onClick={onBack} />
            <WebsiteBuilderToolbar hubName={hubName} hubUrl={hubUrl} />
        </div>
    );
};
